import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ApiMentionedWave } from "@/generated/models/ApiMentionedWave";
import WaveDropPart from "./WaveDropPart";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ImageScale } from "@/helpers/image.helpers";
import useIsTouchDevice from "@/hooks/useIsTouchDevice";
interface WaveDropContentProps {
  readonly drop: ExtendedDrop;
  readonly activePartIndex: number;
  readonly setActivePartIndex: (index: number) => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly onLongPress: () => void;
  readonly setLongPressTriggered: (triggered: boolean) => void;
  readonly isEditing?: boolean | undefined;
  readonly isSaving?: boolean | undefined;
  readonly onSave?: ((newContent: string, mentions?: ApiDropMentionedUser[], mentionedWaves?: ApiMentionedWave[]) => void) | undefined;
  readonly onCancel?: (() => void) | undefined;
  readonly isCompetitionDrop?: boolean | undefined;
  readonly mediaImageScale?: ImageScale | undefined;
  readonly hasTouch?: boolean | undefined;
  readonly onLinkCardActionsActiveChange?: ((href: string, active: boolean) => void) | undefined;
}
const WaveDropContent: React.FC<WaveDropContentProps> = t0 => {
  const $ = _c(16);
  const {
    drop,
    activePartIndex,
    setActivePartIndex,
    onDropContentClick,
    onQuoteClick,
    onLongPress,
    setLongPressTriggered,
    isEditing: t1,
    isSaving: t2,
    onSave,
    onCancel,
    isCompetitionDrop: t3,
    mediaImageScale: t4,
    hasTouch,
    onLinkCardActionsActiveChange
  } = t0;
  const isEditing = t1 === undefined ? false : t1;
  const isSaving = t2 === undefined ? false : t2;
  const isCompetitionDrop = t3 === undefined ? false : t3;
  const mediaImageScale = t4 === undefined ? ImageScale.AUTOx450 : t4;
  const isTouchDevice = useIsTouchDevice();
  const effectiveHasTouch = hasTouch ?? isTouchDevice;
  let t5;
  if ($[0] !== activePartIndex || $[1] !== drop || $[2] !== effectiveHasTouch || $[3] !== isCompetitionDrop || $[4] !== isEditing || $[5] !== isSaving || $[6] !== mediaImageScale || $[7] !== onCancel || $[8] !== onDropContentClick || $[9] !== onLinkCardActionsActiveChange || $[10] !== onLongPress || $[11] !== onQuoteClick || $[12] !== onSave || $[13] !== setActivePartIndex || $[14] !== setLongPressTriggered) {
    t5 = <WaveDropPart drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onDropContentClick={onDropContentClick} onQuoteClick={onQuoteClick} onLongPress={onLongPress} setLongPressTriggered={setLongPressTriggered} isEditing={isEditing} isSaving={isSaving} onSave={onSave} onCancel={onCancel} isCompetitionDrop={isCompetitionDrop} mediaImageScale={mediaImageScale} hasTouch={effectiveHasTouch} onLinkCardActionsActiveChange={onLinkCardActionsActiveChange} />;
    $[0] = activePartIndex;
    $[1] = drop;
    $[2] = effectiveHasTouch;
    $[3] = isCompetitionDrop;
    $[4] = isEditing;
    $[5] = isSaving;
    $[6] = mediaImageScale;
    $[7] = onCancel;
    $[8] = onDropContentClick;
    $[9] = onLinkCardActionsActiveChange;
    $[10] = onLongPress;
    $[11] = onQuoteClick;
    $[12] = onSave;
    $[13] = setActivePartIndex;
    $[14] = setLongPressTriggered;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
export default WaveDropContent;